export default "__VITE_ASSET__BDRh4RNs__"